/**
 * Checks if a form is valid based on its configuration, data, and current errors.
 * @param {Array} formFieldList - The JSON list of input configurations.
 * @param {Object} formData - The current state of the form values.
 * @param {Object} validationErrors - The current state of error messages.
 * @returns {Boolean}
 */
export const isFormValid = (
  formFieldList = [],
  formData = {},
  validationErrors = {},
) => {
  // 1. Check if all required fields have values
  const requiredFields = formFieldList.filter((input) => input.required);

  const allRequiredFilled = requiredFields.every((field) => {
    const val = formData[field.name];

    // Check for null, undefined, empty string, or empty arrays
    return (
      val !== undefined &&
      val !== null &&
      val !== "" &&
      (Array.isArray(val) ? val.length > 0 : true)
    );
  });

  // // 2. Check if there are any active error messages
  // // We check if every error entry is either empty string, null, or undefined
  // const hasNoErrors = Object.values(validationErrors).every((err) => !err);

  // 2. Create an array of currently visible/active field names
  const activeFieldNames = formFieldList.map((field) => field.name);

  // 3. Check for errors ONLY on currently active fields
  const hasNoErrors = Object.keys(validationErrors).every((fieldName) => {
    // If the field is currently hidden/removed from JSON, ignore its error
    if (!activeFieldNames.includes(fieldName)) {
      return true;
    }

    // If the field is visible, ensure its error value is empty/falsy
    return !validationErrors[fieldName];
  });

  return allRequiredFilled && hasNoErrors;
};

export const buttonStyle = (
  formFieldList = [],
  formData = {},
  validationErrors = {},
  loading = false,
) => ({
  opacity:
    isFormValid(formFieldList, formData, validationErrors) && !loading
      ? 1
      : 0.5,
  cursor:
    isFormValid(formFieldList, formData, validationErrors) && !loading
      ? "pointer"
      : "not-allowed",
  backgroundColor:
    isFormValid(formFieldList, formData, validationErrors) && !loading
      ? "#7BD755"
      : "#ccc",
});
